export const getPrivilegesForLocation = (location, hasPrivileges) => {
  if (location.includes("Rules") || location.includes("Events") || location.includes("Settings") || location.includes("GeneralSettings")) {
    return hasPrivileges;
  } else return true;
};
